import { DatePicker, DatePickerProps } from '@progress/kendo-react-dateinputs';
import { useRef, KeyboardEvent } from 'react';

export default function KwelloDatePicker(props: DatePickerProps) {
  const datePickerRef = useRef<DatePicker>(null);

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Tab' && event.target instanceof HTMLInputElement) {
      const input = event.target; // Get the input element
      const value = input.value; // Get the current value of the input
      const selectionStart = input.selectionStart ?? 0;
      const segments = value.split('/'); // Split into MM, DD, YYYY
      const monthLength = segments[0].length; // 1 or 2 digits
      const dayLength = segments[1].length; // 1 or 2 digits

      if (selectionStart < monthLength) {
        // Move cursor to day (skip the / separator)
        event.preventDefault();
        input.setSelectionRange(monthLength + 1, monthLength + 1 + dayLength);
      } else if (selectionStart < monthLength + 1 + dayLength) {
        // Move cursor to year (skip the second / separator)
        event.preventDefault();
        input.setSelectionRange(monthLength + 1 + dayLength + 1, value.length);
      }
    }
  };
  return (
    <div onKeyDown={handleKeyDown}>
      <DatePicker ref={datePickerRef} {...props} />
    </div>
  );
}
